export default "__VITE_ASSET__D9h1AZEs__"